import React, { useState ,useRef,useEffect} from 'react';
import { Modal, Form, FormControl, InputGroup } from 'react-bootstrap';
import { CanselIcon, CardFail, CloseModalIcon } from './Icons';
import { USER_PROFILE } from '../constants/routes';
import Avatar from './Avatar';
import { Link ,useHistory} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Loader from './Loader';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import API from '../API';
import AddPaymentModal from './AddPaymentModal';
import { ReactComponent as SendTipIcon } from '../images/send-tip.svg';
import ButtonComponent from './generic-components/ButtonComponent';
import { VerifiedIcon } from 'components/Icons';
import { handleDecimalDots } from 'helpers';

const TipModal = ({ user, post = null, card, onSubmit, disabled = false, sendTipText = 'send_tip', column = false, buttonContent }) => {
  const { t } = useTranslation();
  const [cardInfo, setCardInfo] = useState(false);
  const [errorCard, setErrorCard] = useState(false);
  const [show, setShow] = useState(false);
  const [paymentTip, setPaymentTip] = useState(false);
  const tipRef = useRef();
  const history = useHistory();

  const tipModalRef = useRef();
  useEffect(() => {
    if(parseInt(tipRef?.current.parentNode.id) === history.location.state?.tipId){
      handleShow()
    }
  
  }, [])
  const handleClose = () => {
    resetForm();
    setShow(false);
    setPaymentTip(false)
    const scrollY = document.body.style.top
    document.body.style.position = ''
    document.body.style.top = ''
    window.scrollTo(0, parseInt(scrollY || '0') * -1)
    document.querySelector('html').style.height = '';
    window.history.pushState({}, '', '')

  };
  const handleShow = () => {
    if (disabled) return;
    if(!tipRef.current.classList.contains("disable-tip-text")){
      if(history.location.state?.tipId){
        setPaymentTip(true)
      }
      else{

        setShow(true);
      }
      window.history.pushState({}, '', '')
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.position = 'fixed';
      document.querySelector('html').style.height = `${window.innerHeight - 1}px`;
    }
    
  };
  const {
    values,
    status,
    resetForm,
    setValues,
    setFieldValue,
    handleSubmit,
    errors,
    touched,
    handleChange,
    isSubmitting,
  } = useFormik({
    initialValues: {
      amount: '',
      values: ''
    },
    validationSchema: Yup.object().shape({
      amount: Yup.number()
        .required().min(1)
        .typeError('Amount Must Be a Number')
    }),

    onSubmit: (values, { setStatus, setSubmitting, resetForm }) => {
      const params = { amount: values.amount, currency: "ILS" };
      if (post) { params.post_id = post.id; }
      API.post(`payments/send-tip/${user.id}`, params)
        .then(resp => {
          setStatus({
            success: true,
          });
          setSubmitting(false);
          setTimeout(() => {
            handleClose();
          }, 3000);
        })
        .catch(errors => {
          setErrorCard(true)
          setSubmitting(false);
        });
    },


  });
  const handleValue = (e) => {
    if (e.target.value.length <= 6) {
      handleChange(e)

    }
    if (e.target.value.includes(".")) {
      handleChange(e)
      var subValue = e.target.value;
      let fixedValue = (subValue.indexOf(".") >= 0) ? (subValue.substr(0, subValue.indexOf(".")) + subValue.substr(subValue.indexOf("."), 3)) : t;
      setValues(pre => ({ ...pre, amount: fixedValue }));
    }
  }
  return (
    <>
      <div
        id={post && `${post.id}`}
        className={`cursor-pointer d-flex align-items-center tips-icon disabled-tips  ${!user.following && "disable-tip-cont"} ${column ? 'flex-column' : ''}`}
        onClick={handleShow}
      >
        {!buttonContent ? (
          <>
            <SendTipIcon width={24} height={24} viewBox={"0 0 24 24"} path={24} />
            <p ref={tipRef} className={user.following ? 'tip-container ml-2 font-weight-500 font-size-14 uppercase' : 'disable-tip-text tip-container font-weight-500 font-size-14 uppercase'}>{t(`${sendTipText}`)}</p>
          </>
        ) : (
          buttonContent
        )}
      </div>
      {errorCard && <div className="error-card">
        <p>Your card has been declined <span onClick={() => setErrorCard(false)}><CanselIcon /></span></p>
        <div>
          <CardFail />
        </div>
      </div>}

      {post && post.following && card && card.length != 0 ? (
        <Modal
          show={(show && !!user ) || paymentTip}
          onHide={handleClose}
          centered
          size="md"
          id={status && status.success && "sent-tip-success" }
          dialogClassName={`add-payment-modal-container`}
        >
          <h2 className="send-tip-text">{t('Firgunize')}</h2>
          <div  className="add-payment-modal-header-wrap d-flex align-items-start flex-column" style={{ marginTop: '0px' }}>
            <div className={'px-4 d-flex'}>
              <Avatar style={{ marginTop: '-27px' }} className="cursor-pointer" user={user && user.name} size={72} image={user && user.avatar} />
              <Link
                className="user-credentials-wrapper text-left mt-1 ml-1"
                to={USER_PROFILE.replace(':userId?', user.id).replace(':name?', !!user.nickname ? user.nickname : '')}
              >
                <div className={'d-flex align-items-center'}>
                  <p className=" font-weight-bold" style={{ color: '#e7eaf3' }}>{user.name}</p>
                  {user.verification_status === "verified" && (
                    <div className={'h-100 verified-icon-container '}>
                      <VerifiedIcon height="1rem" width="1rem" className="fill-grey ml-x header-icon-grey" />
                    </div>
                  )}
                </div>
                {!!user.nickname && <p style={{ color: '#8B95B1' }}>@{user.nickname}</p>}
              </Link>
            </div>
          </div>
          <Modal.Body>
            <div className="tip-modal-body">
              {status && status.success  ? (
                <div className="subscription-popup clipboard">
                  <p className="profile-elipse-wrapper-text clipboard-text">{t('Your tip has been sent successfully!')}</p>
                  <div>
                  <span className="close-icon" onClick={() => handleClose()}>
                    <CloseModalIcon fill="#fff" style={{ width: '12px' }} />
                  </span>
                    </div>
                </div>
              ) : (
                <Form onSubmit={handleSubmit} className={'send-tip-form-container'}>
                  <Loader isLoadin={isSubmitting} height={222} size={60}>
                    {status &&
                      status.errors &&
                      status.errors.map((err, key) => (
                        <p key={key} className="text-danger my-3 overflow-hidden">
                          {err}
                        </p>
                      ))}
                    <div className="form_wrap">
                      <div className="tip-input-wrapper">
                        <Form.Group className="w-100">
                          <InputGroup className="mt-3 input-group input-group-lg d-flex w-100 flex-column" size="lg">
                            <span className="currency-icon">₪</span>
                            <FormControl
                              id={'amount'}
                          
                              onKeyPress={(event) => {
                                if (!/^[0-9]*\.?[0-9]*$/.test(event.key) || event.key === '.' && handleDecimalDots(event.target.value, '.')) {
                                  event.preventDefault();
                                }
                              }}
                              className="border-bottom border-bottom-dark input-light font-size-12 text-dark-grey w-100"
                              name="amount"
                              autoComplete="off"
                              value={values.amount}
                              onChange={(e) => handleValue(e)}
                            // placeholder={t('1')}
                            // isInvalid={touched.amount && errors.amount}
                            />
                            <small htmlFor="amount" className={'filled-input tip-amount-label'}>{t('Firgunation amount')}</small>
                            <Form.Control.Feedback type="invalid" tooltip>
                              {!!errors.amount && errors.amount}
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </div>
                    </div>
                    <div className="minimum-tip mt-1">
                      <small style={{ color: '#686F8D', fontSize: '12px' }}>{t('Minimum ₪ 1 NIS')}</small>
                    </div>
                    <div className="tip-btns d-flex align-items-center justify-content-between my-4">
                      <ButtonComponent
                        type={'button'}
                        isBold={true}
                        onClick={handleClose}
                        btnText={t('Cancel')}
                        transparent={false}
                        customClass={'tip-modal-button-bordered btn-transparent h-100 px-3 py-1 font-size-14'}
                        textClassName={'h-100 font-size-14 text-dark-gray font-weight-bold'}
                      />
                      <ButtonComponent
                        type={'submit'}
                        isBold={true}
                        btnText={t('Firgunize')}
                        transparent={false}
                        customClass={'tip-modal-button-colored border-radius h-100 px-3 py-1 font-size-14'}
                        textClassName={'h-100 font-size-14 text-dark-gray font-weight-bold'}
                      />
                    </div>
                  </Loader>
                </Form>
              )}
            </div>
          </Modal.Body>
        </Modal>
      ) : (
        <AddPaymentModal card={card} onSubmit={onSubmit} cardInfo={cardInfo} user={user} post={post && post} show={show} onHide={handleClose} />
      )}
    </>
  );
};
export default TipModal;